import _jsx from "@babel/runtime/helpers/jsx";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

var _Icon, _Icon2;

import React, { memo, useState, useEffect, useRef, useMemo } from 'react';
import Icon from 'components/Icon';
import { Wrapper, SelectButton, SelectLabel, Options, Option, OptionLabel, OptionInput, Placeholder, IconsWrapper, ClearValuesWrapper, PlaceholderValueText, Input } from './styles';
import { jsx as _jsx2 } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function Select(_ref) {
  var options = _ref.options,
      defaultValue = _ref.defaultValue,
      name = _ref.name,
      label = _ref.label,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      autocompletePlaceholder = _ref.autocompletePlaceholder;
  var isLongList = Object.keys(options).length > 15;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      search = _useState4[0],
      setSearch = _useState4[1];

  var wrapperRef = useRef();
  var autoCompleteInputRef = useRef();

  var handleToggleBtnClick = function handleToggleBtnClick(e) {
    e.preventDefault();
    setOpen(!isOpen);
  };

  var clearSearch = function clearSearch() {
    setSearch(null);
  };

  var handleChange = function handleChange(event) {
    onChange(_defineProperty({}, name, event.target.value));
    setOpen(false);
    clearSearch();
  };

  var handleClearValue = function handleClearValue() {
    onChange(_defineProperty({}, name, ''));
  };

  var handleDocumentClick = function handleDocumentClick(event) {
    var _wrapperRef$current;

    var targetElement = event.target;

    if (!((_wrapperRef$current = wrapperRef.current) != null && _wrapperRef$current.contains(targetElement)) && wrapperRef.current !== targetElement) {
      setOpen(false);
    }
  };

  var renderPlaceholder = useMemo(function () {
    if (defaultValue) {
      var _options$defaultValue;

      return "".concat((_options$defaultValue = options[defaultValue]) == null ? void 0 : _options$defaultValue.label);
    }

    return placeholder;
  }, [defaultValue]);

  var handleSearch = function handleSearch(e) {
    e.preventDefault();
    setSearch(e.target.value);
  };

  useEffect(function () {
    document.addEventListener('mousedown', handleDocumentClick);
    return function () {
      document.removeEventListener('mousedown', handleDocumentClick);
    };
  }, []);
  return /*#__PURE__*/_jsxs(Wrapper, {
    ref: wrapperRef,
    children: [/*#__PURE__*/_jsx(SelectLabel, {}, void 0, label), /*#__PURE__*/_jsx(SelectButton, {
      "data-empty": true,
      "data-active": isOpen,
      type: "button",
      onClick: handleToggleBtnClick,
      title: label
    }, void 0, /*#__PURE__*/_jsx(Placeholder, {}, void 0, isOpen && isLongList ? /*#__PURE__*/_jsx2(Input, {
      value: search || '',
      ref: autoCompleteInputRef,
      placeholder: autocompletePlaceholder,
      onChange: handleSearch,
      autoFocus: true
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PlaceholderValueText, {}, void 0, renderPlaceholder), /*#__PURE__*/_jsx(IconsWrapper, {}, void 0, !!defaultValue && /*#__PURE__*/_jsx(ClearValuesWrapper, {
        onClick: handleClearValue
      }, void 0, _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
        name: "clear"
      }))), _Icon2 || (_Icon2 = /*#__PURE__*/_jsx(Icon, {
        name: "dropdownArrow"
      })))]
    }))), isOpen && /*#__PURE__*/_jsx(Options, {}, void 0, Object.keys(options).map(function (item, index) {
      var option = options[item];
      var isMatch = search;

      if (isMatch) {
        isMatch = option.label.toLowerCase().includes(search.toLowerCase().trim());

        if (!isMatch) {
          return null;
        }
      }

      return /*#__PURE__*/_jsx(Option, {
        htmlFor: "".concat(name, "-option-").concat(index)
      }, option.value, /*#__PURE__*/_jsx(OptionInput, {
        id: "".concat(name, "-option-").concat(index),
        type: "radio",
        name: name,
        value: option.value,
        checked: defaultValue === option.value,
        onChange: handleChange
      }), /*#__PURE__*/_jsx(OptionLabel, {}, void 0, option.label));
    }))]
  });
}

Select.defaultProps = {
  defaultValue: null,
  label: null,
  autocompletePlaceholder: null
};
export default /*#__PURE__*/memo(Select);